var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4401 12.79C15.4701 11.4 16.02 9.75 16.02 8.01C16.02 3.59 12.43 0 8.01001 0C3.59001 0 0 3.59 0 8.01C0 12.43 3.59001 16.02 8.01001 16.02C9.65001 16.02 11.2401 15.5 12.5701 14.58L17.64 19.65C17.64 19.65 19.11 18.18 19.21 18.08L14.2001 13.07C14.2801 12.97 14.3601 12.89 14.4401 12.79ZM8.01001 13.83C4.80001 13.83 2.19006 11.22 2.19006 8.01C2.19006 4.8 4.80001 2.19 8.01001 2.19C11.22 2.19 13.83 4.8 13.83 8.01C13.83 9.27 13.4301 10.47 12.6801 11.48C11.5701 12.97 9.87001 13.83 8.01001 13.83Z",
    fill: "#EB001B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c2f861a5f283147df5905228bf655025.svg";
export { ForwardRef as ReactComponent };